const defaultName = 'WS';

export function capitalizeInitials(inputString: string) {
  if (!inputString) return defaultName;

  const processedString = inputString.replace(/[^A-Za-z0-9\s]/g, '').trim();

  if (!processedString) {
    return defaultName;
  }
  const hasOneWord = processedString.split(' ').length < 2;

  if (hasOneWord) {
    const initials = [];
    initials.push(processedString.slice(0, 1).toUpperCase());
    initials.push(processedString.slice(1, 2).toUpperCase());

    return initials.join('');
  } else {
    const initials = [];
    processedString.split(' ').map((word: string) => {
      initials.push(word.charAt(0).toUpperCase());
    });

    return initials.slice(0, 2).join('');
  }
}
